import { createFileRoute } from "@tanstack/react-router";
import Component from "./-components/component";
import { UsersListSchema, BranchSchema } from "./-components/types";
import { Loading } from "@/layouts/loading";
import { pharmacyClient } from "@/connect";
import getCompanyCode from "@/utils/company_code";

export const Route = createFileRoute("/company/_layout/settings/")({
  component: Component,
  loader: async () => {
    const companyCode = getCompanyCode();
    if (!companyCode) {
      throw new Error("Company code is missing");
    }

    try {
      const branchesResponse = await pharmacyClient.getBranchesForCompany({
        companyCode: companyCode,
      });

      const branches: BranchSchema[] = branchesResponse.branches.map((branch) => ({
        pharmacy_code: branch.pharmacyCode,
        pharmacy_name: branch.pharmacyName,
      }));

      if (branches.length === 0) {
        return { users: [], branches: [] };
      }

      const usersResponse = await pharmacyClient.getUsersInPharmacy({
        pharmacyCode: branches[0].pharmacy_code,
      });

      const users: UsersListSchema[] = usersResponse.users.map((user) => ({
        user_id: user.userId,
        username: user.username,
        full_name: user.fullName,
      }));

      return { users, branches };
    } catch (error) {
      console.error("Loader error:", error);
      throw new Error("Failed to fetch company settings data");
    }
  },
  pendingComponent: () => <Loading />,
  pendingMinMs: 1000,
  pendingMs: 1,
});